import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 26em;
    background-color: ${vars.colorSecondary};
    border-radius: 0.5em;
    text-align: center;
    padding: 3em 6em 3em 6em;

    .contact-info-details-wrapper {
        display: flex;
        flex-direction: column;
        gap: 0.8em;
    }

    .contact-info-headline {
        font-size: 1.9em;
    }

    .divider {
        width: 100%;
    }

    .logo-wrapper {
        margin: 1.2em 0 0 0;
        display: flex;
        align-items: center;
    }

    .logo-title {
        font-size: 1em;
        letter-spacing: 0.39em;
        color: ${vars.colorTextWhite};
    }
`;
